import { useCallback, useState } from 'react';
import { createContainer } from '../../../utils/container';
function useLocalMessages() {
    const [localMessages, setLocalMessages] = useState({});
    const putLocalMessage = useCallback((threadAddr, msg) => {
        setLocalMessages((prev) => {
            const threadMessages = prev[threadAddr];
            if (!threadMessages) {
                return {
                    ...prev,
                    [threadAddr]: [msg],
                };
            }
            return {
                ...prev,
                [threadAddr]: [
                    msg,
                    ...threadMessages.filter((prevMsg) => prevMsg.deduplicationId !== msg.deduplicationId),
                ],
            };
        });
    }, []);
    const deleteLocalMessage = useCallback((threadAddr, id) => {
        setLocalMessages((prev) => {
            const threadMessages = prev[threadAddr];
            if (!threadMessages) {
                return {
                    ...prev,
                    [threadAddr]: [],
                };
            }
            return {
                ...prev,
                [threadAddr]: threadMessages.filter((prevMsg) => prevMsg.deduplicationId !== id),
            };
        });
    }, []);
    return { localMessages, putLocalMessage, deleteLocalMessage };
}
export const LocalMessages = createContainer(useLocalMessages);
//# sourceMappingURL=index.js.map